/**
 * tc-angular-chartjs - http://carlcraig.github.io/tc-angular-chartjs/
 * Copyright (c) 2017 Carl Craig
 * Dual licensed with the Apache-2.0 or MIT license.
 */
!(function (t, e) {
  'function' == typeof define && define.amd
    ? define(['angular', 'chart.js'], e)
    : 'object' == typeof exports
    ? (module.exports = e(require('angular'), require('chart.js')))
    : (t.tcAngularChartjs = e(t.angular, t.Chart));
})(this, function (t, e) {
  function r(t) {
    return new t();
  }
  function n(t) {
    return new t('line');
  }
  function a(t) {
    return new t('bar');
  }
  function c(t) {
    return new t('horizontalbar');
  }
  function i(t) {
    return new t('radar');
  }
  function o(t) {
    return new t('polararea');
  }
  function u(t) {
    return new t('pie');
  }
  function s(t) {
    return new t('doughnut');
  }
  function h(t) {
    return new t('bubble');
  }
  function d() {
    return function (r) {
      function n(n, c, i) {
        var o,
          u = c[0].getContext('2d'),
          s = !1,
          h = !1,
          d = !1,
          l = null;
        for (var f in i)
          'chartLegend' === f
            ? (s = !0)
            : 'chart' === f
            ? (d = !0)
            : 'autoLegend' === f && (h = !0);
        n.$on('$destroy', function () {
          o && 'function' == typeof o.destroy && o.destroy();
        }),
          n.click &&
            (c[0].onclick = function (t) {
              var e = {
                chartEvent: t,
                element: o.getElementAtEvent(t),
                elements: o.getElementsAtEvent(t),
                dataset: o.getDatasetAtEvent(t),
              };
              n.click({ event: e });
            }),
          n.$watch(
            '[data, options, plugins]',
            function (i) {
              if (i && n.data) {
                o && 'function' == typeof o.destroy && o.destroy();
                var f = r || n.type;
                if (!f) throw 'Error creating chart: Chart type required.';
                (f = a(f)),
                  (o = new e(u, {
                    type: f,
                    data: t.copy(n.data),
                    options: n.options,
                    plugins: n.plugins,
                  })),
                  s && (n.legend = o.generateLegend()),
                  h &&
                    (l && l.remove(),
                    t.element(c[0]).after(o.generateLegend()),
                    (l = t.element(c[0]).next())),
                  d && (n.chart = o),
                  o.resize();
              }
            },
            !0,
          );
      }
      function a(t) {
        switch (t.toLowerCase()) {
          case 'polararea':
            return 'polarArea';
          case 'horizontalbar':
            return 'horizontalBar';
          default:
            return t;
        }
      }
      return {
        restrict: 'A',
        scope: {
          data: '=chartData',
          options: '=chartOptions',
          plugins: '=chartPlugins',
          type: '@chartType',
          legend: '=?chartLegend',
          chart: '=?chart',
          click: '&chartClick',
        },
        link: n,
      };
    };
  }
  function l() {
    function t(t, e) {
      t.$watch(
        'legend',
        function (t) {
          t && e.html(t);
        },
        !0,
      );
    }
    return { restrict: 'A', scope: { legend: '=?chartLegend' }, link: t };
  }
  return (
    (r.$inject = ['TcChartjsFactory']),
    (n.$inject = ['TcChartjsFactory']),
    (a.$inject = ['TcChartjsFactory']),
    (c.$inject = ['TcChartjsFactory']),
    (i.$inject = ['TcChartjsFactory']),
    (o.$inject = ['TcChartjsFactory']),
    (u.$inject = ['TcChartjsFactory']),
    (s.$inject = ['TcChartjsFactory']),
    (h.$inject = ['TcChartjsFactory']),
    t
      .module('tc.chartjs', [])
      .directive('tcChartjs', r)
      .directive('tcChartjsLine', n)
      .directive('tcChartjsBar', a)
      .directive('tcChartjsHorizontalbar', c)
      .directive('tcChartjsRadar', i)
      .directive('tcChartjsPolararea', o)
      .directive('tcChartjsPie', u)
      .directive('tcChartjsDoughnut', s)
      .directive('tcChartjsBubble', h)
      .directive('tcChartjsLegend', l)
      .factory('TcChartjsFactory', d),
    d
  );
});
